<template>
  <div class="pc_container">
    <!-- {role}{title} -->
    <PageHeader
      type="5"
      :hasBack="false"
      :title="
        buyerOrSeller
          ? $t('pcFollow.titleWithRole', { role: buyerOrSeller, title })
          : title
      "
      v-if="userInfo.businessType == 20 || userInfo.businessType == 10"
    ></PageHeader>

    <div class="follow_container">
      <!-- 顶部筛选 + 搜索条（公用组件） -->
      <div v-if="userInfo.businessType == 20 || userInfo.businessType == 10">
        <!-- 搜索商品名称、料号、品牌、类型、数量 -->
        <FilterSearchBar
          v-model="searchValue"
          :placeholder="$t('pcFollow.searchPlaceholder')"
          @search="get"
          @filter-click="handleFilterClick"
        />
      </div>
      <s-w ref="refSw" v-if="userInfo.businessType == 20"></s-w>
      <t-p-r ref="refTpr" v-else-if="userInfo.businessType == 10"></t-p-r>
      <div v-else class="empty">
        <!-- 请先登录！ -->
        <el-empty
          :description="$t('pcFollow.loginRequired')"
          v-if="!userInfo.token"
        ></el-empty>
        <!-- 你不是谈判人，请申请成为谈判人 -->
        <el-empty :description="$t('pcFollow.notNegotiator')" v-else>
          <!-- 审核中 -->
          <!-- 申请成为谈判人 -->
          <el-button
            @click="onJump()"
            round
            type="danger"
            class="bottom-button"
            >{{
              $t(
                userInfo.shopStatus == 0
                  ? "pcFollow.underReview"
                  : "pcFollow.applyNegotiator",
              )
            }}</el-button
          >
        </el-empty>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "@/components/pc/PageHeader.vue";
import FilterSearchBar from "@/components/pc/FilterSearchBar.vue";
import TPR from "@/views/pc/follow/tpr/index1.vue";
import SW from "@/views/pc/follow/sw/index1.vue";
import { getUserInfoDetail } from "@/api/user";
import { listPendingClue, swPendingFollowList } from "@/api/bizOppor";

export default {
  name: "pcFollow",
  components: {
    PageHeader,
    FilterSearchBar,
    TPR,
    SW,
  },
  data() {
    return {
      active: 0,
      searchValue: "",
      isEdit: false,
      userInfo: {},
      clueList: [],
      preOrderList: [],
      hasNewClue: false,
    };
  },
  computed: {
    title() {
      // 商务跟单页
      // 谈判人跟单页
      return this.$t(
        this.userInfo.businessType == 20
          ? "pcFollow.businessTracking"
          : "pcFollow.negotiatorTracking",
      );
    },
    path() {
      return this.userInfo.businessType == 20
        ? "/follow/swPendingFollow"
        : "/follow/PendingFollow";
    },
    // 买方/卖方标识
    buyerOrSeller() {
      // 销售商务-销售商务（韦柳艳）：13132782131
      // 采购商务-采购商务（黄心雨）：17307846384
      var mobile = this.userInfo.mobile || "";
      if (this.userInfo.businessType == 20) {
        if (mobile == "13132782131" || mobile == "17307846384") {
          // 只有特殊的这两个商务才有前缀
          // 买家
          // 货主
          return this.$t(
            mobile == "13132782131" ? "pcFollow.buyer" : "pcFollow.seller",
          );
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
  },

  created() {
    this.getUserInfo();
  },
  methods: {
    // 搜索事件
    get(value) {
      this.$refs.refSw?.get(value);
      this.$refs.refTpr?.get(value);
    },
    // 顶部筛选点击（预留扩展）
    handleFilterClick() {
      // TODO: 打开筛选弹窗 / 抽屉，这里先占位
      console.log("点击筛选");
    },
    async getUserInfo() {
      const response = await getUserInfoDetail();
      if (response.code === 200) {
        this.userInfo = response.data.userInfo;
        this.getHasNewClue(this.userInfo.businessType);
      }
    },
    async getHasNewClue(businessType) {
      // sw
      if (businessType == 20) {
        const res = await swPendingFollowList();
        this.hasNewClue = res.rows.length > 0;
      } else if (businessType == 10) {
        // tpr
        const res = await listPendingClue();
        this.hasNewClue = res.rows.length > 0;
      }
    },
    onJump() {
      if (this.userInfo.shopStatus == 0) {
        // 正在审核中
        this.$message(this.$t("pcFollow.reviewInProgress"));
      } else {
        this.$router.push("/applybroker");
      }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.follow_container {
  background-color: #fff;
  .empty {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
